import { Component, Input } from '@angular/core';
import {DatePipe} from "@angular/common";
import { Account } from '../../models/accountmodel';
import { accountService }   from '../../services/account.service';
import { SharedService }   from '../../services/sharedservices.service';
import { Session } from '../../models/sessionmodel';
import { PaymentResponse } from '../../models/responsemodel';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import {Router} from  '@angular/router';
import { CurrencyPipe } from '@angular/common';
//import { DataTableResource } from 'angular-2-data-table';

@Component({
  templateUrl: './profile.component.html',
  styleUrls: ['../../css/sb-admin.min.css'],
  providers: [accountService]
})

export class ProfileComponent {
  @Input() responseObj: Session;
  public account: Account;
  errorMessage: string;


  constructor(public _accountService: accountService, public router: Router, public sharedservice: SharedService) {
    
  }

  ngOnInit()
  {   
      // call the method on initial load of page to bind dropdown
      //this.getAccount();                
  }

}



// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/app/account/profile.component.ts